// extracted by mini-css-extract-plugin
export default {"tagsTopCities":"aiTcU"};